import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'dayjs/locale/it';
import dayjs from 'dayjs';
import { Provider } from 'react-redux';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { persistor, store } from './features/store.ts';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/sonner.tsx';
import { PersistGate } from 'redux-persist/integration/react';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.locale('it');
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.extend(customParseFormat);

const rootElement = document.getElementById('root');

export const IS_MVP = import.meta.env.VITE_REMOVE_MVP_FEATURES !== 'true';

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </PersistGate>
  </Provider>,
);
